import React, { useEffect, useState } from "react";
import { AccountCircle, Block, ContactMail, DeleteForever, Info, Language, LogoutRounded, Policy, Description, Copyright, Article, HelpOutline, QuestionAnswer } from "@mui/icons-material/";
import Tooltip from '@mui/material/Tooltip';
import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Icon,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { CSSObject, Theme, styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { NAV_OPTIONS, PAGE_ROUTES, PRIVACY_POLICY_URL } from "../../utils/constants";
import { colors } from "../../theme";
import { isMobile } from "react-device-detect";
import { useAuth } from "../../context/AuthContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { logoutUser } from "../../pages/UserLogin/AuthSignIn";
import { getUser, setUser } from "../../store/reducers/user.reducer";
import { useDispatch } from "react-redux";
import { setChannel } from "../../store/reducers/channel.reducer";
import { useTranslation } from "react-i18next";
import AboutUsDialog from "../../pages/AboutUsDialog/AboutUsDialog";
import UploadVideo from "../UploadVideo/UploadVideo";
import { useAppSelector } from "../../store/hooks";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function MiniDrawer(props: any) {
  const [open, setOpen] = useState(props.isMenuOpen);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [openLang, setOpenLang] = useState(false);
  const [openAboutUs, setOpenAboutUs] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  let { pathname } = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [activeTab, setActiveTab] = useState(0);

  // SSR-safe: Check authentication on client side only
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsAuthenticated(!!localStorage.getItem("token"));
    }
  }, []);

  const changeLanguage = (lng: string) => {
    setOpenLang(false);
    i18n.changeLanguage(lng);
    localStorage.setItem("appLanguage", lng);
  };

  const openPrivacyPolicy = (url: string) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleDrawerClose = () => {
    props.handleDrawerClose();
  };

  const handleLogoutConfirmation = () => {
    setLogoutDialogOpen(true);
  };

  const confirmLogout = async () => {
    try {
      const userID = localStorage.getItem("userID"); // Dynamically fetch
      const videoID = "3965261569"; // Set or get dynamically
      const response = await logoutUser(userID, videoID);

      // Clear token and user info
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("persist:root")
      dispatch(setChannel(null));
      dispatch(setUser(null)); // Update global state
      navigate("/login");
      navigate(0);// Redirect to login page
    } catch (error) {
      alert("Logout failed. Please try again.");
    }
    setLogoutDialogOpen(false);
  };


  useEffect(() => {
    setOpen(props.isMenuOpen);
  }, [props.isMenuOpen]);

  useEffect(() => {

    if (pathname === "/") {
      setActiveTab(0);
    } else
      setActiveTab(
        NAV_OPTIONS.findIndex(
          ({ path }) => path !== PAGE_ROUTES.HOME && pathname.includes(path)
        )
      );
  }, [pathname]);

  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    setMoreAnchorEl(event.currentTarget);
  };

  const handleMoreClose = () => {
    setMoreAnchorEl(null);
  };

  const openMoreMenu = Boolean(moreAnchorEl);

  return (
    <Drawer variant="permanent" open={open}>
      <DrawerHeader>
        {/* <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton> */}
        {/* <IconButton onClick={handleDrawerClose}>
          <img src="assets/IndeeFlixLogo.svg" alt=""/>
        </IconButton> */}
      </DrawerHeader>
      <Divider />
      <List>
        {/* {NAV_OPTIONS.map(({ text, path, icon }, index) => (
          <Tooltip key={text} title={text} arrow>
            <ListItem key={text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => {
                  navigate(path);
                }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  color: activeTab === index ? colors.blueDark : "grey",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: activeTab === index ? colors.blueDark : "grey",
                  }}
                >
                  <Icon>{icon}</Icon>
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  sx={{
                    opacity: open ? 1 : 0,
                    color: activeTab === index ? colors.blueDark : "grey",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Tooltip>
        ))} */}

        {NAV_OPTIONS.filter(({ text }) => !(!isMobile && text === "Upload")).map(({ text, path, icon }, index) => {
          if (text === "More") {
            return (
              <Tooltip key={text} title={t(`nav.${text}`)} arrow disableInteractive>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    onClick={handleMoreClick}
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <Icon>{icon}</Icon>
                    </ListItemIcon>
                    <ListItemText
                      primary={t(`nav.${text}`)}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </Tooltip>
            );
          }

          // default nav options
          return (
            <Tooltip key={text} title={t(`nav.${text}`)} arrow disableInteractive>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  onClick={() => navigate(path)}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    color: activeTab === index ? colors.blueDark : "grey",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                      color: activeTab === index ? colors.blueDark : "grey",
                    }}
                  >
                    <Icon>{icon}</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={t(`nav.${text}`)}
                    sx={{
                      opacity: open ? 1 : 0,
                      color: activeTab === index ? colors.blueDark : "grey",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Tooltip>
          );
        })}

      </List>
      {isAuthenticated ?
        <>
          <Divider />
          <Tooltip title={t("logoutDialog.logout")} arrow disableInteractive>
            <List>
              {[
                {
                  text: t("logoutDialog.logout"),
                  TextIcon: <LogoutRounded />,
                  onClick: handleLogoutConfirmation,
                },
              ].map(({ text, TextIcon, onClick }) => (
                <ListItem
                  key={text}
                  disablePadding
                  sx={{ display: "block" }}
                  onClick={onClick}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      {TextIcon}
                    </ListItemIcon>
                    <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Tooltip>
        </> : null
      }
      {/* Logout Confirmation Dialog */}
      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
      >
        <DialogTitle>{t("logoutDialog.logoutConfirmLabel")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("logoutDialog.logoutConfirmation")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutDialogOpen(false)} color="primary">
            {t("logoutDialog.cancel")}
          </Button>
          <Button onClick={confirmLogout} color="primary">
            {t("logoutDialog.logoutConfirm")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLang}
        onClose={() => setOpenLang(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            width: 300,
            maxWidth: "100%",
            borderRadius: 3,
          }
        }}
      >
        <DialogTitle>{t("selectLanguage")}</DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <List>
            <ListItemButton onClick={() => changeLanguage("en")}>
              <ListItemIcon>
                <Language />
              </ListItemIcon>
              <Typography>{t("english")}</Typography>
            </ListItemButton>

            <ListItemButton onClick={() => changeLanguage("hi")}>
              <ListItemIcon>
                <Language />
              </ListItemIcon>
              <Typography>हिन्दी</Typography>
            </ListItemButton>
          </List>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenLang(false)} color="primary">
            {t("logoutDialog.cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      <AboutUsDialog openAboutUs={openAboutUs} onClose={() => setOpenAboutUs(false)} />

      <Menu
        anchorEl={moreAnchorEl}
        open={openMoreMenu}
        onClose={handleMoreClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            minWidth: 240,
            p: 1,
          },
        }}
      >
        {/* Heading */}
        <Box px={2} py={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: 600, textTransform: "uppercase" }}
          >
            {t("nav.moreOptions")}
          </Typography>
        </Box>

        {/* Items */}
        <MenuItem
          onClick={() => {
            handleMoreClose();
            setOpenLang(true);
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Language fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.appLanguage")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.appLanguageSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/about");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Info fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.aboutUs")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.aboutUsSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/privacy-policy");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Policy fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.privacyPolicy")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.privacyPolicySubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/terms");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Description fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.termsOfService")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.termsOfServiceSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/contact");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <ContactMail fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.contactUs")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.contactUsSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/dmca");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Copyright fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.dmca")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.dmcaSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/blog");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <Article fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.blog")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.blogSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/help");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <HelpOutline fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.helpCenter")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.helpCenterSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/faq");
          }}
          sx={{ alignItems: "flex-start" }}
        >
          <ListItemIcon>
            <QuestionAnswer fontSize="small" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2">{t("nav.faq")}</Typography>
            <Typography variant="caption" color="text.secondary">
              {t("nav.faqSubtext")}
            </Typography>
          </Box>
        </MenuItem>

        {isAuthenticated && (
          <>
            <MenuItem
              onClick={() => {
                handleMoreClose();
                navigate("/blocked-channels");
              }}
              sx={{ alignItems: "flex-start" }}
            >
              <ListItemIcon>
                <Block fontSize="small" />
              </ListItemIcon>
              <Box>
                <Typography variant="body2">{t("nav.blockedChannels")}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {t("nav.blockedChannelsSubtext")}
                </Typography>
              </Box>
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleMoreClose();
                navigate("/blocked-videos");
              }}
              sx={{ alignItems: "flex-start" }}
            >
              <ListItemIcon>
                <Block fontSize="small" />
              </ListItemIcon>
              <Box>
                <Typography variant="body2">{t("nav.blockedVideos")}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {t("nav.blockedVideosSubtext")}
                </Typography>
              </Box>
            </MenuItem>
          </>
        )}
        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/delete-account");
          }}
          sx={{ alignItems: "flex-start", color: "error.main" }}
        >
          <ListItemIcon>
            <DeleteForever fontSize="small" color="error" />
          </ListItemIcon>
          <Box>
            <Typography variant="body2" color="error">
              {t("deleteDialog.deleteAccount")}
            </Typography>
            <Typography variant="caption" color="error">
              {t("deleteDialog.deleteAccountSubtext")}
            </Typography>
          </Box>
        </MenuItem>
      </Menu>

    </Drawer>
  );
}

export const BottomNav = () => {
  const [value, setValue] = useState(0);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const user = useAppSelector((state) => getUser(state));

  const [moreAnchorEl, setMoreAnchorEl] = useState<null | HTMLElement>(null);

  const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
    // setMoreAnchorEl(event.currentTarget);
    navigate("/more-options");
  };

  const handleMoreClose = () => {
    setMoreAnchorEl(null);
  };

  const openMoreMenu = Boolean(moreAnchorEl);

  return (
    <>
      <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{
            display: "flex",
            width: "100%",
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          {NAV_OPTIONS.filter(({ text }) => !(isMobile && text === "Subscriptions")).map(({ text, path, icon }, index) => {
            const labelText =
              isMobile && text === "More" ? t(`nav.You`) : t(`nav.${text}`);
            if (text === "More") {
              return (
                <BottomNavigationAction
                  key={text}
                  label={labelText}
                  icon={
                    isMobile ? (
                      user ? (
                        <Avatar
                          src={user?.profilePic}
                          sx={{
                            width: 28,
                            height: 28,
                          }}
                        >
                          {user?.username?.[0]?.toUpperCase() || <AccountCircle />}
                        </Avatar>
                      ) : (
                        <AccountCircle />
                      )
                    ) : (
                      <Icon>{icon}</Icon>
                    )
                  }
                  onClick={handleMoreClick}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    maxWidth: `${100 / (NAV_OPTIONS.length - 1)}%`,
                    padding: "6px 0",
                  }}
                />
              );
            }

            return (
              <BottomNavigationAction
                key={text}
                label={t(`nav.${text}`)}
                icon={<Icon>{icon}</Icon>}
                onClick={() => { if (text === "Upload") { setUploadOpen(true) } else { navigate(path) } }}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  maxWidth: `${100 / (NAV_OPTIONS.length - 1)}%`,
                  padding: "6px 0",
                }}
              />
            );
          })}
        </BottomNavigation>
      </Paper>

      <Menu
        anchorEl={moreAnchorEl}
        open={openMoreMenu}
        onClose={handleMoreClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            handleMoreClose();
            navigate("/delete-account");
          }}
        >
          {t("deleteDialog.deleteAccount")}
        </MenuItem>
      </Menu>

      <Dialog
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <UploadVideo
          width="100%"
          onEditSuccess={() => setUploadOpen(false)}
          onModalClose={() => setUploadOpen(false)}
        />
      </Dialog>
    </>
  );
};

export default function Navbar(props: any) {
  return isMobile ? null : <MiniDrawer {...props} />;
}
function dispatch(arg0: { payload: any; type: "channel/setChannel"; }) {
  throw new Error("Function not implemented.");
}

